import { render } from "./EditLiveDataPosition.vue?vue&type=template&id=5b221be2"
import script from "./EditLiveDataPosition.vue?vue&type=script&lang=js"
export * from "./EditLiveDataPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__